export default class WebsocketConnector {
    constructor(_url, _api) {
        this.needToReconnect = true;
        this.alive = false;
        this.connecting = false;
        this.url = _url;
        this.api = _api;
        this.usedChannels = new Set();
        this.initWebsocket = this.initWebsocket.bind(this);
        this.websocketResque = this.websocketResque.bind(this);
        this.webSocketOpenAction = this.webSocketOpenAction.bind(this);
        this.pingAlive = this.pingAlive.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.hangupWebSocket = this.hangupWebSocket.bind(this);
    }
    hangupWebSocket() {
        var _a;
        (_a = this.websocket) === null || _a === void 0 ? void 0 : _a.close();
    }
    initWebsocket() {
        // alert(1);
        let me = this;
        if (me.connecting)
            return;
        me.connecting = true;
        try {
            let url = `${me.api.serverUrl.replace("https", "wss")}/${me.url}`;
            console.log(`Enabling websocket on ${url}`);
            me.websocket = new WebSocket(url); //"wss://erconf.ru/ws");
            // alert(2);
        }
        catch (e) {
            console.log(e);
            setTimeout(me.initWebsocket, 2000);
            return;
        }
        me.websocket.onerror = (_e) => { if (me.websocket)
            me.websocketResque(); };
        me.websocket.onclose = (_e) => { if (me.websocket)
            me.websocketResque(); };
        me.websocket.onopen = (event) => {
            // alert(3);
            me.webSocketOpenAction();
        };
        me.websocket.onmessage = (_message) => {
            let parsed = JSON.parse(_message.data);
            if (parsed["title"] === "PONG") {
                return;
            }
            let channelName = parsed["channel"];
            // alert(_message.data);
            let data = parsed["data"];
            if (typeof data === 'string' || data instanceof String) {
                data = JSON.parse(data.toString());
            }
            me.usedChannels.add(channelName);
            const messageEvent = new CustomEvent(channelName, { detail: data });
            // alert(dogFound);
            document.dispatchEvent(messageEvent);
        };
    }
    webSocketOpenAction() {
        let me = this;
        if (!me.websocket) {
            me.needToReconnect = true;
            setTimeout(me.websocketResque, 5000);
            return;
        }
        try {
            // alert(4);
            let message = JSON.stringify({
                title: "connect",
                session_id: me.api.sessionContainer.currentEntity.peer_id,
                user_id: me.api.sessionContainer.currentEntity.id,
                conferenceId: me.api.sessionContainer.currentEntity.conferenceId
            });
            me.sendMessage(message);
            // alert(5);
            me.needToReconnect = false;
            me.alive = true;
            me.connecting = false;
            setTimeout(() => {
                me.pingInterval = setInterval(me.pingAlive, 5000);
            });
            me.usedChannels.forEach((_channelName) => {
                let event = new CustomEvent(_channelName, {
                    detail: {
                        title: "RESTART"
                    }
                });
                document.dispatchEvent(event);
            });
        }
        catch (e) {
            me.connecting = false;
            console.log(e);
            setTimeout(me.websocketResque, 5000);
        }
    }
    websocketResque() {
        var _a;
        let me = this;
        me.needToReconnect = true;
        me.alive = false;
        if (me.pingInterval)
            clearInterval(me.pingInterval);
        (_a = me.websocket) === null || _a === void 0 ? void 0 : _a.close(3001);
        delete me.websocket;
        setTimeout(me.initWebsocket, 3000);
    }
    pingAlive() {
        this.sendMessage(JSON.stringify({ title: "PING" }));
    }
    sendMessage(_content) {
        let me = this;
        try {
            if (me.websocket) {
                me.websocket.send(_content);
                return true;
            }
            return false;
        }
        catch (e) {
            console.log(e);
            setTimeout(() => {
                me.websocketResque();
            });
            return false;
        }
    }
}
